export enum InsuranceGroup {    
    NoneSelected = 0,
    Aetna = 1,
    Anthem = 2,
    AnthemBcBs = 3,
    BcBc = 4,
    BlueCross = 5,
    BlueShield = 6,
    Cigna = 7,
    HealthAssurance = 8,
    Healthnet = 9,
    Humana = 10,
    Kaiser = 11,
    Medicaid = 12,
    Medicare = 13,
    MedicareAOnly = 19,
    MedicareAdvantage = 20,
    MediCal = 14,
    Tricare = 15,
    TriWest = 39,
    UnitedHealthcare = 16,
    Wellpoint = 17,
    Other = 18
}